import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { GenericTag } from "@ui-components/Tag/GenericTag";

export interface CustomerNotificationSettings {
    tenantId: number;
    customerId: string
    customerName: string
    notificationModuleEnabled: boolean
    enabledNotifications: string[]
    recipients: string[]
  }

export const customerColumns: GenericTableColumn<CustomerNotificationSettings>[] = [
    {
        header: "Customer",
        accessor: "customerName",
    },
    {
        header: "Customer ID",
        accessor: "customerId",
    },
    {
        header: "Notification Module",
        renderCell: row => {
            const status = row.notificationModuleEnabled;
            let variant: "success"|"default"|"error"|"warning";
            let label: string;
            if (status === true) {
            variant = "success";
            label = "Enabled";
        } else if (status === undefined) {
            variant = "default";
            label = "Unknown";
        } else if (status === false) {
            variant = "error";
            label = "Disabled";
        } else {
            variant = "warning";
            label = "Alert";
        }
        return <GenericTag variant={variant} label={label} size="small" rounded="full" />;
        },		
    },
];
